import Button from 'blocks/Button';
import BaseModal from 'components/modals/BaseModal';
import { Transfer } from 'pages/miles/View/viwe.interface';
import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './TransferTransactionDetailModal.styles';
import { ContentProps } from './transferTransactionDetail.interface';

const Content = ({ open, closeModal, transfer }: ContentProps) => {
  const { t } = useTranslation();
  if (!transfer) return null;

  return (
    <S.FlightDetailModal>
      <S.GrayCard>
        <div>
          {t('pages.miles.view.modals.transfer.text', {
            mile: transfer.mile,
            enLname: transfer.from.enLname,
            enFname: transfer.from.enFname,
            enLname2: transfer.to.enLname,
            enFname2: transfer.to.enFname,
          })}
        </div>
      </S.GrayCard>

      <S.BtnContainer>
        <S.Btn as={Button} styleType="default" className="fs-xs" onClick={closeModal}>
          {t('pages.miles.view.modals.details.closeCTA')}
        </S.Btn>
      </S.BtnContainer>
    </S.FlightDetailModal>
  );
};

interface State {
  open: boolean;
  transfer: Transfer | null;
}

interface Props {
  ref: any;
}

class TransferDetailTransactionModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
      transfer: null,
    };
  }

  openModal = (transfer: Transfer): void => this.setState({ open: true, transfer });

  closeModal = (): void => this.setState({ open: false });

  render() {
    return (
      <S.FlightDetailModalContainer as={BaseModal} open={this.state.open} closeModal={this.closeModal}>
        {this.state.transfer ? (
          <Content {...this.props} open={this.state.open} closeModal={this.closeModal} transfer={this.state.transfer} />
        ) : null}
      </S.FlightDetailModalContainer>
    );
  }
}

export default TransferDetailTransactionModal;
